import React from 'react';
import classnames from 'classnames';
import ZonePool from '@gik/ads/ZonePool';
import { adBlockElName } from '@gik/ads/components/AdContainer';

export interface IAdGlareProps {
  zone: string | ZonePool;
  fallbackBackEl?: JSX.Element;
}

export default function AdGlare({ zone, fallbackBackEl }: IAdGlareProps) {
  const [scriptRef, setScriptRef] = React.useState<HTMLScriptElement>(null);
  const [zoneId, setZoneId] = React.useState<string>(null);
  const [showFallback, setShowFallback] = React.useState<boolean>(!zone);
  const placeHolderRef = React.useRef<HTMLSpanElement>(null);

  const blockName = 'adglare';
  const blockClassNames: string = classnames([blockName]);

  const placeholderElName = `${blockName}__placeholder`;
  const placeholderElClassNames: string = classnames([
    placeholderElName,
    adBlockElName,
    showFallback ? `${adBlockElName}--fallback` : undefined,
  ]);

  React.useEffect(() => {
    if (!zoneId) {
      if (zone instanceof ZonePool) {
        setZoneId(zone.getZone());
      } else if (typeof zone === 'string') {
        setZoneId(zone);
      }
    }

    return () => {
      if (zone instanceof ZonePool) {
        zone.freeZone(zoneId);
      }
    };
  }, []);

  React.useEffect(() => {
    if (!scriptRef && zoneId) {
      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.setAttribute('data-cfasync', 'false');
      scriptElement.src =
        '//' + process.env.ADGLARE_NAME + '.engine.adglare.net/?' + zoneId + '&cb=' + Date.now() + Math.random();

      scriptElement.onload = function () {
        setTimeout(() => {
          setShowFallback(placeHolderRef.current?.children.length == 0);
        }, 2000);
      };

      scriptElement.onerror = function () {
        setShowFallback(true);
      };

      setScriptRef(scriptElement);

      const firstScriptElement = document.getElementsByTagName('script')[0];
      firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
    }
  }, [zoneId]);

  return (
    <div className={blockClassNames}>
      <span ref={placeHolderRef} className={placeholderElClassNames} id={`zone${zoneId}`}>
        {showFallback && fallbackBackEl}
      </span>
    </div>
  );
}
